var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g, _path32, _path33, _path34, _path35, _g2, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g3, _path52, _path53, _path54, _g4, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _g5, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _g6, _path91, _path92, _g7, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudAutomation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_291_4210)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4863 78.3797C40.5403 73.6103 44.8328 69.0793 49.6023 65.0253C83.5846 35.5739 132.114 29.9698 173.966 43.2051C215.937 56.4403 251.827 86.2493 280.801 121.185C294.036 137.163 306.675 154.691 324.442 164.349C347.335 176.869 373.925 174.246 398.606 177.942C488.63 191.416 517.962 317.687 456.436 383.386C432.231 409.26 398.368 423.926 366.293 434.896C321.818 450.039 275.316 460.055 228.695 458.147C182.074 456.239 135.095 442.05 97.5352 412.479C48.2907 373.728 18.7201 311.486 6.43878 247.576C0.238496 215.263 -2.02699 181.519 4.17329 149.206C9.18121 123.213 20.0317 98.0537 36.4863 78.3797Z",
    fill: "#92E3A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M398.726 178.062C373.924 174.365 347.454 176.988 324.561 164.469C306.795 154.691 294.156 137.164 280.92 121.305C251.827 86.4882 215.937 56.5599 174.085 43.3247C131.994 29.9702 83.5845 35.5743 49.6022 65.0257C44.952 69.0797 40.5402 73.6107 36.4862 78.3801C20.0316 98.0541 9.30035 123.213 4.29243 149.326C-1.90785 181.639 0.357637 215.382 6.55792 247.695C18.8392 311.606 48.4098 373.847 97.6543 412.599C135.214 442.17 182.193 456.359 228.814 458.266C275.435 460.174 321.938 450.158 366.413 435.015C398.487 424.046 432.35 409.499 456.555 383.505C518.081 317.806 488.749 191.416 398.726 178.062Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.595703 492.248H511.403",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M257.072 107.712V111.885",
    stroke: "#92E3A9",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M257.072 120.947V134.779",
    stroke: "#92E3A9",
    strokeWidth: 3,
    strokeLinejoin: "round",
    strokeDasharray: "7.68 7.68"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M257.072 139.31V143.483H252.898",
    stroke: "#92E3A9",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M244.552 143.482H113.869",
    stroke: "#92E3A9",
    strokeWidth: 3,
    strokeLinejoin: "round",
    strokeDasharray: "7.07 7.07"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.697 143.482H105.523V147.656",
    stroke: "#92E3A9",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M105.523 154.452V164.826",
    stroke: "#92E3A9",
    strokeWidth: 3,
    strokeLinejoin: "round",
    strokeDasharray: "5.74 5.74"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M105.523 168.165V172.338",
    stroke: "#92E3A9",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M126.629 127.505H143.56",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M130.443 86.7256C125.316 89.2295 121.739 94.4759 121.739 100.557C121.739 102.346 122.097 104.015 122.574 105.565C122.335 105.565 121.978 105.565 121.739 105.565C115.658 105.565 110.77 110.454 110.77 116.535C110.77 122.616 115.658 127.504 121.739 127.504",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M163.83 73.8485C161.684 73.1331 159.538 72.7754 157.153 72.7754C148.449 72.7754 140.937 77.7833 137.36 85.176C137.24 85.176 137.121 85.176 137.002 85.176",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M181.716 91.8531C180.762 91.8531 179.927 91.9723 178.973 92.0915C178.258 86.3682 175.277 81.2411 170.984 77.7832",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M154.291 127.504H181.715C191.612 127.504 199.482 119.516 199.482 109.738",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M340.299 128.458H351.865",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M342.804 100.796C339.346 102.465 336.842 106.042 336.842 110.216C336.842 111.408 337.08 112.481 337.438 113.554C337.2 113.554 337.08 113.554 336.842 113.554C332.669 113.554 329.33 116.893 329.33 121.066C329.33 125.239 332.669 128.578 336.842 128.578",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M365.458 92.0914C364.027 91.6144 362.477 91.376 360.927 91.376C354.965 91.376 349.957 94.8338 347.453 99.8417C347.334 99.8417 347.334 99.8417 347.215 99.8417",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M377.621 104.254C377.025 104.254 376.429 104.254 375.713 104.373C375.236 100.438 373.209 96.9803 370.229 94.7148",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M359.02 128.459H377.62C384.298 128.459 389.663 123.093 389.663 116.416",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M297.017 49.4056C295.586 49.4056 294.155 49.5249 292.725 49.7633C290.459 32.8318 276.032 19.7158 258.385 19.7158C244.672 19.7158 232.868 27.7046 227.264 39.2705C227.026 39.2705 226.906 39.2705 226.668 39.2705C213.433 39.2705 202.701 50.0018 202.701 63.237C202.701 65.9794 203.178 68.6026 204.013 70.9874C203.536 70.9874 203.178 70.8681 202.701 70.8681C193.162 70.8681 185.412 78.6185 185.412 88.1574C185.412 97.6963 193.162 105.327 202.701 105.327H297.017C312.518 105.327 325.038 92.8076 325.038 77.3069C325.038 61.8062 312.518 49.4056 297.017 49.4056Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M257.312 77.7846V57.7529",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M268.401 64.5489L257.312 53.46L246.104 64.5489",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M257.312 82.1963V86.7273",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M257.312 91.9736V95.4315",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M221.542 492.248H197.933C192.09 492.248 188.155 487.598 189.109 481.756L198.29 424.403C199.244 418.56 204.729 413.91 210.453 413.91H282.948",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M208.307 398.052H229.531C230.842 398.052 232.035 398.886 232.512 400.079L235.016 406.518H279.968C284.618 406.518 288.553 409.498 289.983 413.672L292.487 413.91C298.33 413.91 302.265 418.56 301.311 424.403L292.13 481.756C291.176 487.598 285.691 492.248 279.968 492.248H235.135",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M187.32 442.169V426.191V417.13C187.32 411.525 191.613 407.114 197.098 406.637L199.602 400.079C200.079 398.886 201.271 398.052 202.583 398.052",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M197.932 492.249C192.09 492.249 187.439 487.479 187.439 481.756V458.505",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M422.811 492.248C419.83 492.248 417.445 489.863 417.445 486.883V454.212C417.445 451.35 419.592 449.085 422.334 448.965L423.646 445.627C423.884 445.031 424.48 444.554 425.196 444.554H438.789C439.504 444.554 440.1 444.911 440.339 445.627L441.65 448.846H464.305C466.69 448.846 468.598 450.396 469.313 452.423",
    fill: "#92E3A9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_291_4210",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 417,
    y: 444,
    width: 53,
    height: 49
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M422.811 492.248C419.83 492.248 417.445 489.863 417.445 486.883V454.212C417.445 451.35 419.592 449.085 422.334 448.965L423.646 445.627C423.884 445.031 424.48 444.554 425.196 444.554H438.789C439.504 444.554 440.1 444.911 440.339 445.627L441.65 448.846H464.305C466.69 448.846 468.598 450.396 469.313 452.423",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_291_4210)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M422.811 492.248C419.83 492.248 417.445 489.863 417.445 486.883V454.212C417.445 451.35 419.592 449.085 422.334 448.965L423.646 445.627C423.884 445.031 424.48 444.554 425.196 444.554H438.789C439.504 444.554 440.1 444.911 440.339 445.627L441.65 448.846H464.305C466.69 448.846 468.598 450.396 469.313 452.423",
    fill: "black",
    fillOpacity: 0.7
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M422.811 492.248C419.83 492.248 417.445 489.863 417.445 486.883V454.212C417.445 451.35 419.592 449.085 422.334 448.965L423.646 445.627C423.884 445.031 424.48 444.554 425.196 444.554H438.789C439.504 444.554 440.1 444.911 440.339 445.627L441.65 448.846H464.305C466.69 448.846 468.598 450.396 469.313 452.423",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M422.811 492.248H464.186C467.167 492.248 469.909 489.864 470.386 487.002L475.036 458.028C475.513 455.047 473.486 452.781 470.625 452.781H429.25C426.269 452.781 423.526 455.166 423.049 458.028L418.399 487.002C417.803 489.864 419.83 492.248 422.811 492.248Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M181.477 492.248C178.496 492.248 176.111 489.863 176.111 486.883V454.212C176.111 451.35 178.258 449.085 181 448.965L182.312 445.627C182.55 445.031 183.146 444.554 183.862 444.554H197.455C198.17 444.554 198.766 444.911 199.005 445.627L200.316 448.846H222.971C225.356 448.846 227.264 450.396 227.979 452.423",
    fill: "#92E3A9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_291_4210",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 176,
    y: 444,
    width: 52,
    height: 49
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M181.477 492.248C178.496 492.248 176.111 489.863 176.111 486.883V454.212C176.111 451.35 178.258 449.085 181 448.965L182.312 445.627C182.55 445.031 183.146 444.554 183.862 444.554H197.455C198.17 444.554 198.766 444.911 199.005 445.627L200.316 448.846H222.971C225.356 448.846 227.264 450.396 227.979 452.423",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_291_4210)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M181.477 492.248C178.496 492.248 176.111 489.863 176.111 486.883V454.212C176.111 451.35 178.258 449.085 181 448.965L182.312 445.627C182.55 445.031 183.146 444.554 183.862 444.554H197.455C198.17 444.554 198.766 444.911 199.005 445.627L200.316 448.846H222.971C225.356 448.846 227.264 450.396 227.979 452.423",
    fill: "black",
    fillOpacity: 0.7
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M181.477 492.248C178.496 492.248 176.111 489.863 176.111 486.883V454.212C176.111 451.35 178.258 449.085 181 448.965L182.312 445.627C182.55 445.031 183.146 444.554 183.862 444.554H197.455C198.17 444.554 198.766 444.911 199.005 445.627L200.316 448.846H222.971C225.356 448.846 227.264 450.396 227.979 452.423",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M181.477 492.248H222.852C225.833 492.248 228.575 489.864 229.052 487.002L233.702 458.028C234.179 455.047 232.152 452.781 229.291 452.781H187.916C184.935 452.781 182.192 455.166 181.715 458.028L177.065 487.002C176.469 489.864 178.496 492.248 181.477 492.248Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M327.182 475.437C327.182 475.437 329.09 486.883 327.182 492.249H289.146C289.146 492.249 287.596 488.195 289.146 485.691C290.696 483.187 302.739 481.756 306.554 478.298C310.251 474.841 314.305 468.998 314.305 468.998L327.182 475.437Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M288.549 490.222H327.658L328.016 492.249H288.549V490.222Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M318.121 474.006C318.121 474.006 314.544 474.84 314.186 474.96C313.829 475.079 310.251 480.445 306.794 481.398C303.336 482.352 299.878 482.114 300.355 483.902",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M310.131 474.006L314.185 476.987",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M308.225 476.629L312.159 479.491",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M305.721 478.895L309.179 482.233",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M302.381 480.563L303.812 483.902",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M327.778 480.563C327.778 480.563 321.578 479.848 314.662 482.233C307.865 484.618 305.481 486.764 305.6 487.36C305.719 487.956 306.554 489.864 306.554 489.864H310.012C310.012 489.864 308.819 487.718 309.058 487.36C309.296 487.002 320.981 482.471 327.659 483.306V480.563H327.778Z",
    fill: "#263238"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M391.69 492.248C391.69 492.248 393.121 486.644 391.451 484.617C388.351 480.921 391.809 477.821 388.709 476.509L387.397 478.059C387.159 476.509 387.874 471.859 382.151 471.263C375.235 470.547 375.116 475.555 374.758 477.225L374.877 474.959C371.896 474.959 373.447 477.94 369.035 482.71C365.577 486.406 365.577 491.056 365.815 492.368H391.69V492.248Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M416.73 279.531C419.949 281.439 428.176 298.967 423.407 333.784C418.638 368.601 404.21 436.684 401.825 447.177C399.441 457.551 390.975 482.59 390.975 482.59C390.975 482.59 387.755 471.74 372.255 477.582C371.659 477.821 371.062 477.344 371.182 476.629L374.639 458.862C374.639 458.862 374.878 445.866 375.951 442.646C380.124 430.365 382.27 383.028 383.701 376.351C385.132 369.793 382.39 350.715 382.39 350.715C382.39 350.715 362.954 397.217 362.358 401.868C361.762 406.399 349.838 425.476 349.838 425.476L347.811 443.004C347.811 443.004 332.072 470.071 329.21 478.179L310.371 474.125L310.848 460.77L315.856 458.982L324.679 428.576C324.679 428.576 328.018 415.103 334.934 397.575C339.107 386.963 351.031 346.065 351.031 346.065C354.727 342.011 358.185 319.952 358.185 319.952L363.908 292.051L416.73 279.531Z",
    fill: "#263238"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M337.795 205.724L299.162 234.818L274.242 195.589L264.941 196.781C264.941 196.781 283.423 247.337 293.677 252.465C303.932 257.472 342.564 229.571 342.564 229.571",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M337.795 205.724L299.162 234.818L274.242 195.589L264.941 196.781C264.941 196.781 283.423 247.337 293.677 252.465C303.932 257.472 342.564 229.571 342.564 229.571",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M346.261 199.882C346.261 199.882 335.053 203.817 327.541 210.255C320.029 216.813 308.105 226.471 308.105 226.471C308.105 226.471 314.902 242.568 322.652 249.246L339.345 242.568L346.261 199.882Z",
    fill: "#92E3A9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_291_4210",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 308,
    y: 199,
    width: 39,
    height: 51
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M346.261 199.882C346.261 199.882 335.053 203.817 327.541 210.255C320.029 216.813 308.105 226.471 308.105 226.471C308.105 226.471 314.902 242.568 322.652 249.246L339.345 242.568L346.261 199.882Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_291_4210)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M322.652 249.126L328.733 243.641C324.56 242.211 323.964 233.626 326.349 236.13C328.733 238.634 332.668 239.468 332.668 239.468C329.568 231.002 330.88 222.894 330.88 222.894C330.88 222.894 332.907 228.618 334.099 234.341C334.934 238.157 337.676 240.661 338.868 242.091L346.261 199.882C346.261 199.882 335.053 203.817 327.541 210.255C320.029 216.813 308.105 226.471 308.105 226.471C308.105 226.471 314.902 242.449 322.652 249.126Z",
    fill: "white"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M346.261 199.882C346.261 199.882 335.053 203.817 327.541 210.255C320.029 216.813 308.105 226.471 308.105 226.471C308.105 226.471 314.902 242.568 322.652 249.246L339.345 242.568L346.261 199.882Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M339.346 242.568C345.785 258.427 356.039 278.339 356.039 278.339L360.57 300.517C360.57 300.517 377.501 313.395 396.818 308.029C419.473 301.709 423.169 287.401 423.169 287.401L414.584 269.993C411.603 253.3 407.787 213.952 394.433 204.89C381.079 195.947 358.304 195.112 349.123 198.809C340.896 202.028 336.365 204.532 334.219 207.513",
    fill: "#92E3A9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_291_4210",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 334,
    y: 196,
    width: 90,
    height: 114
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M339.346 242.568C345.785 258.427 356.039 278.339 356.039 278.339L360.57 300.517C360.57 300.517 377.501 313.395 396.818 308.029C419.473 301.709 423.169 287.401 423.169 287.401L414.584 269.993C411.603 253.3 407.787 213.952 394.433 204.89C381.079 195.947 358.304 195.112 349.123 198.809C340.896 202.028 336.365 204.532 334.219 207.513",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_291_4210)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M410.172 292.648C389.664 299.206 391.929 294.555 396.699 286.328C400.872 278.816 397.891 270.112 398.01 267.846C397.056 269.635 393.598 275.001 389.306 277.028C383.702 279.651 385.729 280.605 390.617 271.304C395.506 262.004 396.699 251.511 396.699 251.511C391.214 246.145 386.921 232.791 386.921 232.791L404.807 221.821C402.183 214.19 398.845 207.871 394.433 204.89C381.079 195.947 358.304 195.112 349.123 198.809C340.896 202.028 336.365 204.532 334.219 207.513L339.465 242.568C345.904 258.427 356.158 278.339 356.158 278.339L360.689 300.517C360.689 300.517 377.621 313.395 396.937 308.029C419.592 301.709 423.288 287.401 423.288 287.401L422.93 286.686C418.996 289.07 414.822 291.097 410.172 292.648Z",
    fill: "white"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M339.346 242.568C345.785 258.427 356.039 278.339 356.039 278.339L360.57 300.517C360.57 300.517 377.501 313.395 396.818 308.029C419.473 301.709 423.169 287.401 423.169 287.401L414.584 269.993C411.603 253.3 407.787 213.952 394.433 204.89C381.079 195.947 358.304 195.112 349.123 198.809C340.896 202.028 336.365 204.532 334.219 207.513",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M370.583 201.79C370.583 201.79 365.575 211.09 356.752 210.136C349.359 209.421 349.598 203.459 349.598 203.459C349.598 203.459 351.148 202.267 351.863 200.12C352.102 199.524 352.102 198.69 352.102 197.974C351.982 196.186 351.028 193.92 348.524 191.297L348.405 191.178C347.809 190.582 347.451 190.105 347.094 189.508C343.04 182.354 357.229 174.246 367.96 180.208C367.841 180.208 359.494 186.647 370.583 201.79Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M354.964 189.27C354.964 189.27 354.726 194.874 352.102 197.974C351.983 196.186 351.029 193.92 348.525 191.297C349.837 189.747 351.983 188.793 354.964 189.27Z",
    fill: "#263238"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M369.51 173.411C373.565 156.241 365.218 148.729 359.733 146.464C351.029 142.887 339.701 148.491 337.078 158.03C334.455 167.568 336.84 169.715 336.721 173.65C336.601 176.392 334.932 177.704 336.84 184.619C338.032 189.15 340.059 196.424 347.929 195.112C349.479 194.874 351.983 194.277 354.844 192.847",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M369.51 173.411C373.565 156.241 365.218 148.729 359.733 146.464C351.029 142.887 339.701 148.491 337.078 158.03C334.455 167.568 336.84 169.715 336.721 173.65C336.601 176.392 334.932 177.704 336.84 184.619C338.032 189.15 340.059 196.424 347.929 195.112C349.479 194.874 351.983 194.277 354.844 192.847",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M346.855 167.807C346.855 167.807 350.075 166.615 351.863 170.43",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M335.887 165.78C335.887 165.78 339.225 165.065 340.656 167.45",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M341.49 172.338C341.49 172.338 338.151 178.061 338.271 178.896C338.39 181.4 341.609 180.207 341.609 180.207",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M347.453 173.173C347.453 174.008 347.811 174.604 348.288 174.604C348.765 174.604 349.122 174.008 349.122 173.173C349.122 172.338 348.765 171.742 348.288 171.742C347.811 171.742 347.453 172.338 347.453 173.173Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M338.271 172.338C338.271 173.173 338.629 173.769 339.106 173.769C339.583 173.769 339.941 173.173 339.941 172.338C339.941 171.503 339.583 170.907 339.106 170.907C338.629 170.907 338.271 171.623 338.271 172.338Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M347.453 182.593C347.453 182.593 343.876 184.501 340.656 183.666",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M346.856 183.308C346.856 183.308 346.498 185.812 344.113 186.05C341.729 186.289 341.609 183.904 341.609 183.904",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M369.511 151.353C369.511 151.353 369.034 142.171 351.745 142.41C334.575 142.768 329.567 156.003 338.271 159.699C346.975 163.276 352.341 161.726 352.341 161.726C352.341 161.726 349.122 160.772 346.26 157.553C346.26 157.553 352.222 161.13 357.349 162.084C357.349 162.084 355.441 164.707 357.349 169C359.257 173.292 358.303 175.081 358.303 175.081C358.303 175.081 366.172 177.346 364.861 185.812C364.861 185.812 372.134 185.693 374.996 169C378.096 152.306 369.511 151.353 369.511 151.353Z",
    fill: "#263238"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M359.734 176.392C359.734 176.392 362.835 170.55 366.173 171.981C369.512 173.411 367.127 180.446 364.265 182.712C361.404 184.977 359.734 182.712 359.734 182.712",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M359.734 176.392C359.734 176.392 362.835 170.55 366.173 171.981C369.512 173.411 367.127 180.446 364.265 182.712C361.404 184.977 359.734 182.712 359.734 182.712",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M330.879 222.895C332.787 230.645 333.741 236.726 339.345 242.568",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M329.688 216.694C329.807 217.887 330.045 219.079 330.284 220.271",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M396.578 237.679C396.578 237.679 419.591 262.6 425.195 261.646C430.799 260.692 433.78 251.511 432.587 249.007C431.395 246.503 410.648 222.417 410.648 222.417L396.578 237.679Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M387.994 214.309C385.729 222.179 384.775 230.525 388.59 237.083C390.498 242.687 401.348 248.053 405.045 252.703C416.73 249.842 421.738 234.937 421.738 234.937C421.738 234.937 414.941 225.279 408.145 215.263C401.348 205.128 387.756 201.312 387.756 201.312",
    fill: "#92E3A9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_291_4210",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 386,
    y: 201,
    width: 36,
    height: 52
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M387.994 214.309C385.729 222.179 384.775 230.525 388.59 237.083C390.498 242.687 401.348 248.053 405.045 252.703C416.73 249.842 421.738 234.937 421.738 234.937C421.738 234.937 414.941 225.279 408.145 215.263C401.348 205.128 387.756 201.312 387.756 201.312",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_291_4210)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M387.994 214.309C385.729 222.179 384.775 230.525 388.59 237.083C390.498 242.687 401.348 248.053 405.045 252.703C416.73 249.842 421.738 234.937 421.738 234.937C421.738 234.937 414.941 225.279 408.145 215.263C401.348 205.128 387.756 201.312 387.756 201.312",
    fill: "white"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M387.994 214.309C385.729 222.179 384.775 230.525 388.59 237.083C390.498 242.687 401.348 248.053 405.045 252.703C416.73 249.842 421.738 234.937 421.738 234.937C421.738 234.937 414.941 225.279 408.145 215.263C401.348 205.128 387.756 201.312 387.756 201.312",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M274.6 195.947C274.6 195.947 270.784 187.004 268.4 184.143C266.134 181.519 263.63 179.373 262.915 179.254C261.245 179.015 255.88 181.996 255.88 181.996C255.88 181.996 255.88 183.666 258.741 183.427C258.741 183.427 254.568 186.05 254.33 188.077C254.091 190.104 256.714 193.085 257.311 194.158C257.788 195.351 258.861 194.635 258.861 194.635C258.861 194.635 263.392 200.836 267.803 201.313",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M274.6 195.947C274.6 195.947 270.784 187.004 268.4 184.143C266.134 181.519 263.63 179.373 262.915 179.254C261.245 179.015 255.88 181.996 255.88 181.996C255.88 181.996 255.88 183.666 258.741 183.427C258.741 183.427 254.568 186.05 254.33 188.077C254.091 190.104 256.714 193.085 257.311 194.158C257.788 195.351 258.861 194.635 258.861 194.635C258.861 194.635 263.392 200.836 267.803 201.313",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M258.861 194.873C258.861 194.873 259.338 194.396 259.458 193.204C259.458 193.204 261.246 193.204 261.365 191.654C261.365 191.654 264.108 191.773 262.915 188.435",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M261.364 191.654C261.364 191.654 258.264 188.435 258.145 187.123",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M259.456 193.205C259.456 193.205 256.117 190.224 256.356 188.912",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M262.438 181.639C262.438 181.639 261.127 183.308 259.1 183.427",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M261.723 182.354C261.723 182.354 262.557 183.069 263.273 183.904",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M389.186 211.805C389.901 210.613 390.855 209.54 392.047 208.705",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M365.697 490.222H392.168L391.691 492.249H365.697V490.222Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M374.162 482.352C374.162 482.352 382.866 479.491 387.04 483.068",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M374.162 480.445C374.162 480.445 381.793 478.06 387.04 481.279",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M374.639 478.536C374.639 478.536 381.793 475.794 387.158 479.49",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M368.916 482.591L369.75 483.425C369.989 483.664 369.989 484.022 369.87 484.379C369.273 485.333 367.962 487.718 368.081 490.222H366.77C366.77 490.222 367.246 486.764 368.558 484.379L367.962 483.664L368.916 482.591Z",
    fill: "#263238"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M399.32 265.581C397.77 267.727 377.381 292.29 367.842 290.978",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M346.262 244.476C346.262 244.476 357.708 262.003 375.713 261.646",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.83 331.28C376.903 331.519 396.935 338.792 400.87 346.185",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.601 341.892C379.647 343.322 371.062 369.912 367.485 377.305C363.788 384.578 351.626 417.368 348.765 419.276C348.765 419.276 344.949 438.354 342.684 441.454C340.299 444.554 328.137 468.997 328.137 468.997",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.424 468.998L329.209 472.098",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.639 470.547C374.639 470.547 386.443 469.474 390.497 474.005",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.35 344.992C389.303 350.596 404.208 382.075 407.785 378.498",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.508 347.854C382.508 347.854 380.719 340.103 382.389 336.526C382.985 335.215 369.63 339.865 365.219 338.792",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.6 309.341C380.6 309.341 382.984 316.018 383.461 318.164C384.057 320.311 379.169 328.538 380.6 330.207",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.15 303.021C413.15 303.021 416.489 308.028 416.489 311.844C416.489 315.54 421.02 317.21 421.02 317.21",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.186 297.536C420.186 297.536 424.24 312.679 420.901 331.399C417.563 350 412.197 388.036 410.051 397.694C407.904 407.353 403.016 429.054 403.016 432.154C403.016 435.254 398.008 452.662 398.008 452.662",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.201 426.192C398.486 426.192 385.251 438.951 382.031 439.189",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.49 418.322C340.775 418.561 329.686 423.926 329.209 422.376",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M396.936 319.952C393.955 320.191 391.451 318.044 391.213 315.063L388.589 282.512C388.351 279.77 390.378 277.266 393.12 276.908L394.193 273.45C394.432 272.854 394.909 272.377 395.624 272.258L409.098 271.185C409.813 271.185 410.41 271.542 410.648 272.138L412.198 275.358L434.853 273.569C437.238 273.331 439.265 274.762 440.099 276.789",
    fill: "#92E3A9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_291_4210",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 388,
    y: 271,
    width: 53,
    height: 49
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M396.936 319.952C393.955 320.191 391.451 318.044 391.213 315.063L388.589 282.512C388.351 279.77 390.378 277.266 393.12 276.908L394.193 273.45C394.432 272.854 394.909 272.377 395.624 272.258L409.098 271.185C409.813 271.185 410.41 271.542 410.648 272.138L412.198 275.358L434.853 273.569C437.238 273.331 439.265 274.762 440.099 276.789",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_291_4210)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M396.936 319.952C393.955 320.191 391.451 318.044 391.213 315.063L388.589 282.512C388.351 279.77 390.378 277.266 393.12 276.908L394.193 273.45C394.432 272.854 394.909 272.377 395.624 272.258L409.098 271.185C409.813 271.185 410.41 271.542 410.648 272.138L412.198 275.358L434.853 273.569C437.238 273.331 439.265 274.762 440.099 276.789",
    fill: "black",
    fillOpacity: 0.7
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M396.936 319.952C393.955 320.191 391.451 318.044 391.213 315.063L388.589 282.512C388.351 279.77 390.378 277.266 393.12 276.908L394.193 273.45C394.432 272.854 394.909 272.377 395.624 272.258L409.098 271.185C409.813 271.185 410.41 271.542 410.648 272.138L412.198 275.358L434.853 273.569C437.238 273.331 439.265 274.762 440.099 276.789",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M396.935 319.952L438.191 316.613C441.172 316.375 443.676 313.752 443.914 310.89L446.18 281.677C446.418 278.696 444.272 276.55 441.291 276.789L400.035 280.127C397.054 280.366 394.551 282.989 394.312 285.851L392.047 315.063C391.808 317.925 394.074 320.191 396.935 319.952Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M428.891 244.237C433.183 248.291 435.329 251.511 435.091 264.865C434.733 278.22 432.348 297.536 430.798 310.533L419.471 312.321C419.471 312.321 421.259 291.813 419.471 278.339C417.563 263.554 419.113 255.326 420.782 254.253",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M428.891 244.237C433.183 248.291 435.329 251.511 435.091 264.865C434.733 278.22 432.348 297.536 430.798 310.533L419.471 312.321C419.471 312.321 421.259 291.813 419.471 278.339C417.563 263.554 419.113 255.326 420.782 254.253",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M420.068 300.875C419.83 304.691 412.914 305.883 412.318 308.268C412.199 309.102 409.695 314.349 409.695 314.349C409.695 314.349 409.576 317.21 410.053 318.88C410.649 320.907 412.557 319.714 412.557 319.714L413.153 321.145C414.107 323.53 415.895 321.264 418.876 322.814C421.857 324.245 423.288 322.338 424.48 322.814C425.673 323.291 429.369 322.099 430.084 320.668C430.8 319.237 429.727 313.037 430.8 310.533C431.873 308.029 431.873 303.021 431.873 300.875",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M420.068 300.875C419.83 304.691 412.914 305.883 412.318 308.268C412.199 309.102 409.695 314.349 409.695 314.349C409.695 314.349 409.576 317.21 410.053 318.88C410.649 320.907 412.557 319.714 412.557 319.714L413.153 321.145C414.107 323.53 415.895 321.264 418.876 322.814C421.857 324.245 423.288 322.338 424.48 322.814C425.673 323.291 429.369 322.099 430.084 320.668C430.8 319.237 429.727 313.037 430.8 310.533C431.873 308.029 431.873 303.021 431.873 300.875",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M412.557 319.714C412.557 319.714 412.557 315.899 415.061 314.349Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M412.557 319.714C412.557 319.714 412.557 315.899 415.061 314.349",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M258.026 181.161H151.906V203.101H258.026V181.161Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M258.026 209.658H151.906V231.598H258.026V209.658Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M258.026 238.156H151.906V260.096H258.026V238.156Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M258.026 266.653H151.906V288.593H258.026V266.653Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M258.026 295.151H151.906V317.091H258.026V295.151Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M258.861 205.485H173.846C172.534 205.485 171.461 204.412 171.461 203.101V181.042C171.461 179.73 172.534 178.657 173.846 178.657H258.861C260.173 178.657 261.246 179.73 261.246 181.042V203.101C261.246 204.531 260.173 205.485 258.861 205.485Z",
    fill: "#BFBFBF",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M258.861 233.982H173.846C172.534 233.982 171.461 232.909 171.461 231.598V209.539C171.461 208.227 172.534 207.154 173.846 207.154H258.861C260.173 207.154 261.246 208.227 261.246 209.539V231.598C261.246 232.909 260.173 233.982 258.861 233.982Z",
    fill: "#BFBFBF",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M258.861 262.48H173.846C172.534 262.48 171.461 261.407 171.461 260.096V238.037C171.461 236.725 172.534 235.652 173.846 235.652H258.861C260.173 235.652 261.246 236.725 261.246 238.037V260.096C261.246 261.407 260.173 262.48 258.861 262.48Z",
    fill: "#BFBFBF",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M258.861 290.978H173.846C172.534 290.978 171.461 289.904 171.461 288.593V266.534C171.461 265.223 172.534 264.149 173.846 264.149H258.861C260.173 264.149 261.246 265.223 261.246 266.534V288.593C261.246 289.904 260.173 290.978 258.861 290.978Z",
    fill: "#BFBFBF",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M258.861 319.476H173.846C172.534 319.476 171.461 318.402 171.461 317.091V295.032C171.461 293.721 172.534 292.647 173.846 292.647H258.861C260.173 292.647 261.246 293.721 261.246 295.032V317.091C261.246 318.402 260.173 319.476 258.861 319.476Z",
    fill: "#BFBFBF",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M269.713 196.304C269.713 196.304 263.512 193.562 263.751 189.15C263.87 187.719 262.916 185.931 262.916 185.931C262.916 185.931 256.954 184.5 257.789 182.115L265.897 182.95C265.897 182.95 270.07 185.215 271.859 190.104",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M269.713 196.304C269.713 196.304 263.512 193.562 263.751 189.15C263.87 187.719 262.916 185.931 262.916 185.931C262.916 185.931 256.954 184.5 257.789 182.115L265.897 182.95C265.897 182.95 270.07 185.215 271.859 190.104",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M163.95 178.181H38.8711V492.249H163.95V178.181Z",
    fill: "#757575",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M120.668 205.485H35.6523C34.3407 205.485 33.2676 204.412 33.2676 203.101V181.042C33.2676 179.73 34.3407 178.657 35.6523 178.657H120.668C121.979 178.657 123.052 179.73 123.052 181.042V203.101C123.052 204.531 121.979 205.485 120.668 205.485Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M167.05 205.485H82.0351C80.7235 205.485 79.6504 204.412 79.6504 203.101V181.042C79.6504 179.73 80.7235 178.657 82.0351 178.657H167.05C168.362 178.657 169.435 179.73 169.435 181.042V203.101C169.435 204.531 168.362 205.485 167.05 205.485Z",
    fill: "#BFBFBF",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0352 201.551V182.711C82.0352 181.757 82.7506 181.042 83.7045 181.042H165.381C166.335 181.042 167.051 181.757 167.051 182.711V201.551C167.051 202.505 166.335 203.22 165.381 203.22H83.7045C82.7506 203.101 82.0352 202.385 82.0352 201.551Z",
    fill: "#263238"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M133.783 202.147H88.9505C88.1158 202.147 87.4004 201.431 87.4004 200.597V196.066C87.4004 195.231 88.1158 194.516 88.9505 194.516H133.783C134.618 194.516 135.333 195.231 135.333 196.066V200.597C135.333 201.431 134.618 202.147 133.783 202.147Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M143.084 193.681H98.2512C97.4166 193.681 96.7012 192.965 96.7012 192.131V187.6C96.7012 186.765 97.4166 186.05 98.2512 186.05H143.084C143.919 186.05 144.634 186.765 144.634 187.6V192.131C144.753 192.965 144.038 193.681 143.084 193.681Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M120.668 347.973H35.6523C34.3407 347.973 33.2676 346.9 33.2676 345.588V323.529C33.2676 322.218 34.3407 321.145 35.6523 321.145H120.668C121.979 321.145 123.052 322.218 123.052 323.529V345.588C123.052 346.9 121.979 347.973 120.668 347.973Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M167.05 347.973H82.0351C80.7235 347.973 79.6504 346.9 79.6504 345.588V323.529C79.6504 322.218 80.7235 321.145 82.0351 321.145H167.05C168.362 321.145 169.435 322.218 169.435 323.529V345.588C169.435 346.9 168.362 347.973 167.05 347.973Z",
    fill: "#BFBFBF",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M144.754 332.472H91.4551V336.764H144.754V332.472Z",
    fill: "#757575",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M154.054 334.618C154.054 335.811 153.1 336.764 151.908 336.764C150.716 336.764 149.762 335.811 149.762 334.618C149.762 333.426 150.716 332.472 151.908 332.472C153.1 332.353 154.054 333.426 154.054 334.618Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M161.685 334.618C161.685 335.811 160.731 336.764 159.539 336.764C158.346 336.764 157.393 335.811 157.393 334.618C157.393 333.426 158.346 332.472 159.539 332.472C160.731 332.353 161.685 333.426 161.685 334.618Z",
    fill: "#757575",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M124.484 333.902H93.3633V335.333H124.484V333.902Z",
    fill: "#92E3A9"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M120.668 376.471H35.6523C34.3407 376.471 33.2676 375.398 33.2676 374.086V352.027C33.2676 350.716 34.3407 349.643 35.6523 349.643H120.668C121.979 349.643 123.052 350.716 123.052 352.027V374.086C123.052 375.398 121.979 376.471 120.668 376.471Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M167.05 376.471H82.0351C80.7235 376.471 79.6504 375.398 79.6504 374.086V352.027C79.6504 350.716 80.7235 349.643 82.0351 349.643H167.05C168.362 349.643 169.435 350.716 169.435 352.027V374.086C169.435 375.398 168.362 376.471 167.05 376.471Z",
    fill: "#BFBFBF",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M144.754 360.97H91.4551V365.262H144.754V360.97Z",
    fill: "#757575",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M151.908 365.143C153.093 365.143 154.054 364.182 154.054 362.997C154.054 361.811 153.093 360.851 151.908 360.851C150.723 360.851 149.762 361.811 149.762 362.997C149.762 364.182 150.723 365.143 151.908 365.143Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M161.685 362.997C161.685 364.189 160.731 365.143 159.539 365.143C158.346 365.143 157.393 364.189 157.393 362.997C157.393 361.804 158.346 360.851 159.539 360.851C160.731 360.851 161.685 361.804 161.685 362.997Z",
    fill: "#757575",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M124.484 362.4H93.3633V363.831H124.484V362.4Z",
    fill: "#92E3A9"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M120.668 404.968H35.6523C34.3407 404.968 33.2676 403.895 33.2676 402.583V380.524C33.2676 379.213 34.3407 378.14 35.6523 378.14H120.668C121.979 378.14 123.052 379.213 123.052 380.524V402.583C123.052 403.895 121.979 404.968 120.668 404.968Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M167.05 404.968H82.0351C80.7235 404.968 79.6504 403.895 79.6504 402.583V380.524C79.6504 379.213 80.7235 378.14 82.0351 378.14H167.05C168.362 378.14 169.435 379.213 169.435 380.524V402.583C169.435 403.895 168.362 404.968 167.05 404.968Z",
    fill: "#BFBFBF",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M144.754 389.467H91.4551V393.759H144.754V389.467Z",
    fill: "#757575",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M151.908 393.64C153.093 393.64 154.054 392.679 154.054 391.494C154.054 390.309 153.093 389.348 151.908 389.348C150.723 389.348 149.762 390.309 149.762 391.494C149.762 392.679 150.723 393.64 151.908 393.64Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M161.685 391.494C161.685 392.686 160.731 393.64 159.539 393.64C158.346 393.64 157.393 392.686 157.393 391.494C157.393 390.302 158.346 389.348 159.539 389.348C160.731 389.348 161.685 390.302 161.685 391.494Z",
    fill: "#757575",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M124.484 390.778H93.3633V392.209H124.484V390.778Z",
    fill: "#92E3A9"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M120.668 433.465H35.6523C34.3407 433.465 33.2676 432.392 33.2676 431.08V409.021C33.2676 407.71 34.3407 406.637 35.6523 406.637H120.668C121.979 406.637 123.052 407.71 123.052 409.021V431.08C123.052 432.392 121.979 433.465 120.668 433.465Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M167.05 433.465H82.0351C80.7235 433.465 79.6504 432.392 79.6504 431.08V409.021C79.6504 407.71 80.7235 406.637 82.0351 406.637H167.05C168.362 406.637 169.435 407.71 169.435 409.021V431.08C169.435 432.392 168.362 433.465 167.05 433.465Z",
    fill: "#BFBFBF",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M144.754 417.845H91.4551V422.137H144.754V417.845Z",
    fill: "#757575",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M154.054 419.991C154.054 421.183 153.1 422.137 151.908 422.137C150.716 422.137 149.762 421.183 149.762 419.991C149.762 418.799 150.716 417.845 151.908 417.845C153.1 417.845 154.054 418.799 154.054 419.991Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M161.685 419.991C161.685 421.183 160.731 422.137 159.539 422.137C158.346 422.137 157.393 421.183 157.393 419.991C157.393 418.799 158.346 417.845 159.539 417.845C160.731 417.845 161.685 418.799 161.685 419.991Z",
    fill: "#757575",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M124.484 419.275H93.3633V420.706H124.484V419.275Z",
    fill: "#92E3A9"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M120.668 461.963H35.6523C34.3407 461.963 33.2676 460.89 33.2676 459.578V437.519C33.2676 436.208 34.3407 435.135 35.6523 435.135H120.668C121.979 435.135 123.052 436.208 123.052 437.519V459.578C123.052 460.89 121.979 461.963 120.668 461.963Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M167.05 461.963H82.0351C80.7235 461.963 79.6504 460.89 79.6504 459.578V437.519C79.6504 436.208 80.7235 435.135 82.0351 435.135H167.05C168.362 435.135 169.435 436.208 169.435 437.519V459.578C169.435 460.89 168.362 461.963 167.05 461.963Z",
    fill: "#BFBFBF",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M144.754 446.343H91.4551V450.635H144.754V446.343Z",
    fill: "#757575",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M151.908 450.635C153.093 450.635 154.054 449.674 154.054 448.489C154.054 447.304 153.093 446.343 151.908 446.343C150.723 446.343 149.762 447.304 149.762 448.489C149.762 449.674 150.723 450.635 151.908 450.635Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M161.685 448.489C161.685 449.681 160.731 450.635 159.539 450.635C158.346 450.635 157.393 449.681 157.393 448.489C157.393 447.297 158.346 446.343 159.539 446.343C160.731 446.343 161.685 447.297 161.685 448.489Z",
    fill: "#757575",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M124.484 447.773H93.3633V449.204H124.484V447.773Z",
    fill: "#92E3A9"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M120.668 490.46H35.6523C34.3407 490.46 33.2676 489.387 33.2676 488.075V466.017C33.2676 464.705 34.3407 463.632 35.6523 463.632H120.668C121.979 463.632 123.052 464.705 123.052 466.017V488.075C123.052 489.387 121.979 490.46 120.668 490.46Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M167.05 490.46H82.0351C80.7235 490.46 79.6504 489.387 79.6504 488.075V466.017C79.6504 464.705 80.7235 463.632 82.0351 463.632H167.05C168.362 463.632 169.435 464.705 169.435 466.017V488.075C169.435 489.387 168.362 490.46 167.05 490.46Z",
    fill: "#BFBFBF",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M144.754 474.84H91.4551V479.132H144.754V474.84Z",
    fill: "#757575",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M151.908 479.132C153.093 479.132 154.054 478.171 154.054 476.986C154.054 475.801 153.093 474.84 151.908 474.84C150.723 474.84 149.762 475.801 149.762 476.986C149.762 478.171 150.723 479.132 151.908 479.132Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M161.685 476.986C161.685 478.178 160.731 479.132 159.539 479.132C158.346 479.132 157.393 478.178 157.393 476.986C157.393 475.794 158.346 474.84 159.539 474.84C160.731 474.84 161.685 475.794 161.685 476.986Z",
    fill: "#757575",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M124.484 476.271H93.3633V477.701H124.484V476.271Z",
    fill: "#92E3A9"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M120.668 319.476H35.6523C34.3407 319.476 33.2676 318.402 33.2676 317.091V295.032C33.2676 293.721 34.3407 292.647 35.6523 292.647H120.668C121.979 292.647 123.052 293.721 123.052 295.032V317.091C123.052 318.402 121.979 319.476 120.668 319.476Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M167.05 319.476H82.0351C80.7235 319.476 79.6504 318.402 79.6504 317.091V295.032C79.6504 293.721 80.7235 292.647 82.0351 292.647H167.05C168.362 292.647 169.435 293.721 169.435 295.032V317.091C169.435 318.402 168.362 319.476 167.05 319.476Z",
    fill: "#BFBFBF",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0352 315.422V296.582C82.0352 295.629 82.7506 294.913 83.7045 294.913H165.381C166.335 294.913 167.051 295.629 167.051 296.582V315.422C167.051 316.376 166.335 317.091 165.381 317.091H83.7045C82.7506 317.091 82.0352 316.376 82.0352 315.422Z",
    fill: "#263238"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M133.783 316.137H88.9505C88.1158 316.137 87.4004 315.422 87.4004 314.587V309.937C87.4004 309.102 88.1158 308.387 88.9505 308.387H133.783C134.618 308.387 135.333 309.102 135.333 309.937V314.468C135.333 315.422 134.618 316.137 133.783 316.137Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M160.254 316.137H139.269C138.434 316.137 137.719 315.422 137.719 314.587V309.937C137.719 309.102 138.434 308.387 139.269 308.387H160.254C161.089 308.387 161.804 309.102 161.804 309.937V314.468C161.804 315.422 161.089 316.137 160.254 316.137Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M115.063 308.387H94.0774C93.2428 308.387 92.5273 307.672 92.5273 306.837V302.306C92.5273 301.471 93.2428 300.756 94.0774 300.756H115.063C115.898 300.756 116.613 301.471 116.613 302.306V306.837C116.613 307.672 115.898 308.387 115.063 308.387Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M120.668 290.979H35.6523C34.3407 290.979 33.2676 289.905 33.2676 288.594V266.535C33.2676 265.224 34.3407 264.15 35.6523 264.15H120.668C121.979 264.15 123.052 265.224 123.052 266.535V288.594C123.052 289.905 121.979 290.979 120.668 290.979Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M167.05 290.979H82.0351C80.7235 290.979 79.6504 289.905 79.6504 288.594V266.535C79.6504 265.224 80.7235 264.15 82.0351 264.15H167.05C168.362 264.15 169.435 265.224 169.435 266.535V288.594C169.435 289.905 168.362 290.979 167.05 290.979Z",
    fill: "#BFBFBF",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0352 287.044V268.204C82.0352 267.251 82.7506 266.535 83.7045 266.535H165.381C166.335 266.535 167.051 267.251 167.051 268.204V287.044C167.051 287.998 166.335 288.713 165.381 288.713H83.7045C82.7506 288.594 82.0352 287.878 82.0352 287.044Z",
    fill: "#263238"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M134.499 287.64H113.513C112.678 287.64 111.963 286.924 111.963 286.09V281.559C111.963 280.724 112.678 280.009 113.513 280.009H134.499C135.333 280.009 136.049 280.724 136.049 281.559V286.09C136.049 286.924 135.333 287.64 134.499 287.64Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M160.254 287.64H139.269C138.434 287.64 137.719 286.924 137.719 286.09V281.559C137.719 280.724 138.434 280.009 139.269 280.009H160.254C161.089 280.009 161.804 280.724 161.804 281.559V286.09C161.804 286.924 161.089 287.64 160.254 287.64Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M109.102 287.64H88.2356C87.401 287.64 86.6855 286.924 86.6855 286.09V281.559C86.6855 280.724 87.401 280.009 88.2356 280.009H109.221C110.056 280.009 110.771 280.724 110.771 281.559V286.09C110.771 286.924 110.056 287.64 109.102 287.64Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M128.061 279.412H107.075C106.241 279.412 105.525 278.697 105.525 277.862V273.331C105.525 272.497 106.241 271.781 107.075 271.781H128.061C128.896 271.781 129.611 272.497 129.611 273.331V277.862C129.611 278.697 128.896 279.412 128.061 279.412Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M120.668 262.48H35.6523C34.3407 262.48 33.2676 261.407 33.2676 260.096V238.037C33.2676 236.725 34.3407 235.652 35.6523 235.652H120.668C121.979 235.652 123.052 236.725 123.052 238.037V260.096C123.052 261.407 121.979 262.48 120.668 262.48Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M167.05 262.48H82.0351C80.7235 262.48 79.6504 261.407 79.6504 260.096V238.037C79.6504 236.725 80.7235 235.652 82.0351 235.652H167.05C168.362 235.652 169.435 236.725 169.435 238.037V260.096C169.435 261.407 168.362 262.48 167.05 262.48Z",
    fill: "#BFBFBF",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0352 258.546V239.706C82.0352 238.753 82.7506 238.037 83.7045 238.037H165.381C166.335 238.037 167.051 238.753 167.051 239.706V258.546C167.051 259.5 166.335 260.215 165.381 260.215H83.7045C82.7506 260.096 82.0352 259.38 82.0352 258.546Z",
    fill: "#263238"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M149.285 259.142H104.452C103.618 259.142 102.902 258.426 102.902 257.592V253.061C102.902 252.226 103.618 251.511 104.452 251.511H149.285C150.12 251.511 150.835 252.226 150.835 253.061V257.592C150.835 258.426 150.12 259.142 149.285 259.142Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M143.084 250.676H98.2512C97.4166 250.676 96.7012 249.961 96.7012 249.126V249.365C96.7012 248.53 97.4166 247.814 98.2512 247.814H143.084C143.919 247.814 144.634 248.53 144.634 249.365V249.126C144.753 249.961 144.038 250.676 143.084 250.676Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M120.668 233.983H35.6523C34.3407 233.983 33.2676 232.91 33.2676 231.599V209.54C33.2676 208.228 34.3407 207.155 35.6523 207.155H120.668C121.979 207.155 123.052 208.228 123.052 209.54V231.599C123.052 233.03 121.979 233.983 120.668 233.983Z",
    fill: "#999999",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M167.05 233.983H82.0351C80.7235 233.983 79.6504 232.91 79.6504 231.599V209.54C79.6504 208.228 80.7235 207.155 82.0351 207.155H167.05C168.362 207.155 169.435 208.228 169.435 209.54V231.599C169.435 233.03 168.362 233.983 167.05 233.983Z",
    fill: "#BFBFBF",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0352 230.049V211.209C82.0352 210.255 82.7506 209.54 83.7045 209.54H165.381C166.335 209.54 167.051 210.255 167.051 211.209V230.049C167.051 231.003 166.335 231.718 165.381 231.718H83.7045C82.7506 231.599 82.0352 230.883 82.0352 230.049Z",
    fill: "#263238"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M157.631 230.645H112.798C111.963 230.645 111.248 229.929 111.248 229.095V224.564C111.248 223.729 111.963 223.014 112.798 223.014H157.631C158.466 223.014 159.181 223.729 159.181 224.564V229.095C159.181 229.929 158.466 230.645 157.631 230.645Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M143.084 222.179H122.099C121.264 222.179 120.549 221.464 120.549 220.629V216.098C120.549 215.263 121.264 214.548 122.099 214.548H143.084C143.919 214.548 144.635 215.263 144.635 216.098V220.629C144.754 221.464 144.038 222.179 143.084 222.179Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3945 195.708V202.147",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M40.541 195.708V202.147",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5684 195.708V202.147",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5957 195.708V202.147",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6211 195.708V202.147",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3945 480.683V487.121",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M40.541 480.683V487.121",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5684 480.683V487.121",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5957 480.683V487.121",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6211 480.683V487.121",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3945 452.185V458.623",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M40.541 452.185V458.623",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5684 452.185V458.623",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5957 452.185V458.623",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6211 452.185V458.623",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3945 423.688V430.126",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M40.541 423.688V430.126",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5684 423.688V430.126",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5957 423.688V430.126",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6211 423.688V430.126",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3945 395.19V401.629",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M40.541 395.19V401.629",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5684 395.19V401.629",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5957 395.19V401.629",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6211 395.19V401.629",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3945 366.692V373.131",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M40.541 366.692V373.131",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5684 366.692V373.131",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5957 366.692V373.131",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6211 366.692V373.131",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3945 338.195V344.634",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M40.541 338.195V344.634",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5684 338.195V344.634",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5957 338.195V344.634",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6211 338.195V344.634",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3945 309.698V316.137",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M40.541 309.698V316.137",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5684 309.698V316.137",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5957 309.698V316.137",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6211 309.698V316.137",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3945 281.2V287.639",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M40.541 281.2V287.639",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5684 281.2V287.639",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5957 281.2V287.639",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6211 281.2V287.639",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3945 252.703V259.142",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M40.541 252.703V259.142",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5684 252.703V259.142",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5957 252.703V259.142",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6211 252.703V259.142",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3945 224.205V230.644",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M40.541 224.205V230.644",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5684 224.205V230.644",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5957 224.205V230.644",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6211 224.205V230.644",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_291_4210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 473.844,
    fill: "white",
    transform: "translate(0 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudAutomation);
export default __webpack_public_path__ + "static/media/CloudAutomation.beb9978903e4ddc39f9d60d4de14bb3d.svg";
export { ForwardRef as ReactComponent };